import Vue from 'vue'
import VueI18n from 'vue-i18n'
import getBrowserLocale from '@/util/i18n/get-browser-locale'
import { supportedLocalesInclude } from '@/util/i18n/supported-locales'
import VueCookie from 'vue-cookie'
import en from 'vuetify/lib/locale/en'
import fr from 'vuetify/lib/locale/fr'
import de from 'vuetify/lib/locale/de'
Vue.use(VueI18n)



function getStartingLocale () {
  if (VueCookie.get('locale')) {
    return VueCookie.get('locale')
  }
  
  const browserLocale = getBrowserLocale({ countryCodeOnly: true })
  if (supportedLocalesInclude(browserLocale)) {
    return browserLocale
  } else {
    return process.env.VUE_APP_I18N_LOCALE || 'en'
  }
}

/*
function loadLocaleMessages () {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  )
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1)
    {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}
*/

const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
}




const messages = {
  en: {
    ...require('@/locales/en.json'),
    $vuetify: en,
  },
  fr: {
    ...require('@/locales/fr.json'),
    $vuetify: fr,
  },
  de: {
    ...require('@/locales/de.json'),
    $vuetify: de,
  },
}


export default new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages, // : loadLocaleMessages()
  dateTimeFormats,
})
